import {
  API_ERROR,
  GEN_JWT_FROM_AZURE,
  GEN_JWT_FROM_AZURE_FAIL,
  GEN_JWT_FROM_AZURE_SUCCESS,
  IS_AZURE,
  LOGIN_SUCCESS,
  LOGIN_USER,
  LOGOUT_USER,
  LOGOUT_USER_SUCCESS,
} from "./actionTypes";

const initialState = {
  error: null,
  loading: false,
  azure: {
    isAzure: false,
    loading: false,
    error: null,
  },
};

const login = (state = initialState, action) => {
  switch (action.type) {
    case LOGIN_USER:
      state = {
        ...state,
        loading: true,
        error: null,
      };
      break;
    case LOGIN_SUCCESS:
      state = {
        ...state,
        loading: false,
        error: null,
      };
      break;
    case LOGOUT_USER:
      state = {
        ...state,
        azure: {
          isAzure: false,
          loading: false,
          error: null,
        },
      };
      break;
    case LOGOUT_USER_SUCCESS:
      state = { ...state };
      break;
    case API_ERROR:
      state = { ...state, error: action.payload, loading: false };
      break;
    case GEN_JWT_FROM_AZURE:
      state = {
        ...state,
        azure: {
          isAzure: false,
          loading: true,
          error: null,
        },
      };
      break;
    case GEN_JWT_FROM_AZURE_SUCCESS:
      localStorage.setItem(IS_AZURE, IS_AZURE);
      state = {
        ...state,
        azure: {
          isAzure: true,
          loading: false,
          error: null,
        },
      };
      break;
    case GEN_JWT_FROM_AZURE_FAIL:
      state = {
        ...state,
        azure: {
          isAzure: false,
          loading: false,
          error: action.error,
        },
      };
      break;
    default:
      state = { ...state };
      break;
  }
  return state;
};

export default login;
